<div class="alert alert-danger mb-2" role="alert" *ngIf="erroInicializacao">
  <i class="fas fa-times"></i>
  {{erroInicializacao}}
</div>

<div class="alert alert-danger mb-2" role="alert" *ngIf="msgErro" #erroDiv>
  <i class="fas fa-exclamation-triangle"></i> {{msgErro}}
</div>



<form [ngClass]="{'needs-validation': !formCartao.submitted, 'was-validated': formCartao.submitted}"
      novalidate #formCartao="ngForm" class="form-cartao-tuna" autocomplete="on">
  <div class="card card-dados-cartao mt-2">
    <div class="card-body">
      <div class="bloqueio" *ngIf="(!this.definiuSessao || carregando3ds)">
        <div class="k-icon k-i-loading" [hidden]="erroInicializacao"></div>
      </div>

      <div class="alert alert-danger" *ngIf="erroCartao">
        <i class="fas fa-exclamation-circle"></i>
        {{erroCartao}}
      </div>

      <h5 class="titulo-secao-cartao">Dados do cartão</h5>

      <div class="box-dados-cartao">
        <div class="intro-cartao">
          <div class="icone-intro-cartao">
            <i class="fas fa-credit-card"></i>
          </div>
          <div>
            <strong>Insira os dados do seu cartão</strong>
            <span>Preencha os campos abaixo com as informações do seu cartão.</span>
          </div>
        </div>

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>
              Número do cartão
            </label>
            <div class="campo-cartao com-icone">
              <i class="fas fa-credit-card card-icon"></i>
              <input type="text" class="form-control input-background" autocomplete="cc-number" inputmode="numeric"
                   [mask]="'0000-0000-0000-0009'"
                   id="numero" name="numero" [(ngModel)]="cartao.numero" #numero="ngModel" #numeroElem appAutoFocus
                   required   placeholder="0000 0000 0000 0000" >
              <i class="far fa-credit-card card-icon direita"></i>
            </div>

            <div class="invalid-feedback">
              <p *ngIf="formCartao.submitted && formCartao.form.get('cardNumber')?.errors?.required">
                Número do cartão é obrigatório
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-12">
          <div class="form-group">
            <label>
              Nome do titular
            </label>
            <div class="campo-cartao com-icone">
              <i class="fas fa-user card-icon"></i>
              <kendo-textbox class="form-control  "
                [(ngModel)]="cartao.nome"
                name="cardHolderName"  id="cardHolderName"
                autocomplete="cc-name"
                required
                placeholder="Nome como está no cartão">
              </kendo-textbox>
            </div>
            <div class="invalid-feedback">
              <p *ngIf="formCartao.submitted && formCartao.form.get('cardHolderName')?.errors?.required">
                Nome do titular é obrigatório
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-12">
          <div class="form-group">
            <label>
              CPF do titular
            </label>
            <div class="campo-cartao com-icone">
              <i class="far fa-id-card card-icon"></i>
              <kendo-textbox  [(ngModel)]="cartao.cpf"  class="form-control  "
                              name="cpf"    id="cpf" required #cpf="ngModel"  cpfValido
                              mask="000.000.000-00" cpfValido placeholder="000.000.000-00"  >

              </kendo-textbox>
            </div>
            <div class="invalid-feedback">
              <p *ngIf="cpf.errors?.required">Obrigatório</p>
              <p *ngIf="cpf.errors?.cpfInvalido">CPF é invalido</p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-6">
          <div class="form-group">
            <label>
              Validade
            </label>
            <div class="campo-cartao com-icone">
              <i class="far fa-calendar-alt card-icon"></i>
              <kendo-dateinput name="validade" id="validade" format="MM/yy" class="form-control"
                               autocomplete="cc-exp" required #validade="ngModel"
                               [(ngModel)]="cartao.validade" data-pagarmecheckout-input>

              </kendo-dateinput>

            </div>
            <div class="invalid-feedback">
              <p *ngIf="formCartao.submitted && !cartao.validade">
                Mês é obrigatório
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-6">
          <div class="form-group">
            <label>
              Código segurança (CVV)
            </label>
            <div class="campo-cartao com-icone">
              <i class="fas fa-lock card-icon"></i>
              <kendo-textbox   [(ngModel)]="cartao.cvv"
                name="securityCode" id="securityCode"  class="form-control  "
                autocomplete="cc-csc" inputmode="numeric"
                required placeholder="000" [maxlength]="4">
              </kendo-textbox>
              <i class="far fa-question-circle card-icon direita"></i>
            </div>
            <div class="invalid-feedback">
              <p *ngIf="formCartao.submitted && !cartao.cvv">
                CVV é obrigatório
              </p>
            </div>
          </div>
        </div>

      </div>
      </div>

      <!--<div class="bandeiras-aceitas">
        <img src="assets/img/visa.png" alt="Visa">
        <img src="assets/img/mastercard.png" alt="Mastercard">
        <img src="assets/img/amex.png" alt="American Express">
        <img src="assets/img/elo.png" alt="Elo">
      </div> -->
    </div>
  </div>
</form>

<div class="card mt-3" *ngIf="false">
  <div class="card-body">
    <!-- Container para o frame de coleta de dados 3DS -->
    <div id="frame-container-3ds"></div>

    <!-- Container para o modal de desafio 3DS -->
    <div id="modal-container-3ds"></div>
  </div>
</div>
